import { mapData } from "@/stuff/DataMapping";

export interface IBuyerCoinsService {
    enabled: boolean;
    module: string;
    certificate: string;
}

export class BuyerCoinsService implements IBuyerCoinsService {

    constructor(data?: IBuyerCoinsService) {
        if (data) this.update(data)
    }

    update(data: IBuyerCoinsService): void {
        mapData(data, {
            root: () => this
        });
    }

    enabled: boolean = false;
    module: string = "";
    certificate: string = "";

}

export interface IBuyerCoinsInterface {
    enabled: boolean;
    services: Array<IBuyerCoinsService>;
}

export class BuyerCoinsInterface implements IBuyerCoinsInterface {

    constructor(data?: IBuyerCoinsInterface) {
        if (data) this.update(data);
    }

    update(data: IBuyerCoinsInterface): void {
        mapData(data, {
            root: () => this,
            services: (data:IBuyerCoinsService) => new BuyerCoinsService(data)
        });
    }
    
    enabled: boolean = false;
    services: Array<IBuyerCoinsService> = [];

}